import React from 'react'
import giftcard from "../../Images/gift-icon.png"
import { LineWave } from 'react-loader-spinner'
import { Link } from 'react-router-dom'

function HowRedeem() {
    return (
        <>
            <section className='howworkRewards_page'>
                <div className='cust_container'>
                    <div className="top_area">
                        <Link to="/reward" className="backbtn"> <i className="fa-solid fa-arrow-left-long" /></Link>
                        <h4 className="heading">How redeem</h4>
                        <Link to="/my-wallet" className="icon">
                            <img
                                src={giftcard}
                                className="img-fluid"
                                alt="....."
                            />
                        </Link>
                    </div>

                    <div className='conetnt'>
                        <h4 className='head'>How to Redeem Your Points</h4>
                        <p className='mt-2'>Redeeming your Neoo Search Reward Points is simple and rewarding! Once you’ve collected enough points through your activities—such as adding members, posting updates, or sharing your NeooCard—you can easily exchange them for exciting rewards and exclusive partner offers.</p>
                        <p>Just log in to your Neoo Search account, go to your Rewards Dashboard, and choose from the available redemption options.</p>
                        <p>You can view all current offers in your Rewards section, as well as explore additional partner offers on the Partners page.</p>
                        <p>On the Redeem page, you’ll see offers you are eligible to claim and can instantly issue your voucher.</p>
                        <p>Once issued, the voucher will appear in your My Wallet.</p>
                        <p>To redeem it, visit the partner’s shop and present your voucher.</p>
                        <p>Each voucher includes its own validity and usage instructions—be sure to check the details before visiting.</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HowRedeem